// ConfirmModal.jsx
import React from "react";

const ConfirmModal = ({ isOpen, onConfirm, onCancel, message }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-textBlack bg-opacity-75">
      <div className="bg-primaryVeryLight rounded-lg shadow-lg p-6 w-80">
        <p className="text-cool-gray-700 text-center mb-4">
          {message || "Are you sure?"}
        </p>
        <div className="flex justify-end space-x-3">
          <button
            onClick={onCancel}
            className="px-4 py-2 bg-cool-gray-300 rounded hover:bg-cool-gray-400"
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            className="px-4 py-2 bg-red-600 text-textWhite rounded hover:bg-red-400"
          >
            Confirm
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal;
